import { Component, Input } from '@angular/core';
import { Usuario } from '../usuario';

@Component({
    selector: 'sgt-usuario-acessos',
    templateUrl: './usuario-acessos.component.html',
    styleUrls: ['./usuario-acessos.component.less']
})
export class UsuarioAcessosComponent {
    @Input() isPerfilAdminitrador: boolean;
    @Input() isPerfilRepresentante: boolean;
    @Input() entity: Usuario;
}
